import { Link } from 'react-router';
import { Building2, ShieldCheck } from 'lucide-react';
import { cn } from './ui/utils';

interface DiligentSlimBannerProps {
  organizationName?: string;
  role?: string;
  className?: string;
}

const formatRole = (value?: string) => {
  if (!value) {
    return '';
  }

  return value
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

export function DiligentSlimBanner({ organizationName, role, className }: DiligentSlimBannerProps) {
  const formattedRole = formatRole(role);

  return (
    <div className={cn('flex items-center gap-3 min-w-0', className)}>
      <Link to="/app" className="shrink-0 inline-flex items-center">
        <>
          <img src="/diligent-banner.svg" alt="Diligent" className="h-10 lg:h-11 w-auto dark:hidden" />
          <img src="/diligent-banner-dark.svg" alt="Diligent" className="hidden h-10 lg:h-11 w-auto dark:block" />
        </>
      </Link>

      <div className="hidden md:flex items-center gap-2 min-w-0">
        {organizationName && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-muted/40 text-muted-foreground text-xs max-w-[16rem]">
            <Building2 className="w-3 h-3 shrink-0" />
            <span className="truncate">{organizationName}</span>
          </span>
        )}

        {formattedRole && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs whitespace-nowrap">
            <ShieldCheck className="w-3 h-3" />
            <span>{formattedRole}</span>
          </span>
        )}
      </div>
    </div>
  );
}